import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Chips } from "primereact/chips"; // Import Chips component
import * as Yup from "yup";
import Flex from "../../../../components/shared-styles/flexi";
import { handleSubmit } from "../../../../services/utils/processors";
import styled from "styled-components";

// -- Styled Components for Redesign --
const CardContainer = styled.div`
  min-width: 50vw;
  background-color: var(--surface-card, #ffffff);
  border: 1px solid var(--surface-border, #e5e7eb);
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);

  @media (max-width: 768px) {
    min-width: 100%;
    padding: 16px;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--surface-border, #f3f4f6);
  padding-bottom: 16px;
  
  h3 {
    margin: 0;
    font-size: 1.25rem;
    color: var(--text-color, #374151);
    font-weight: 600;
  }
`;

const StyledChips = styled(Chips)`
  width: 100%;
  
  ul {
    width: 100%;
    border-radius: 8px;
    border: 1px solid var(--surface-border, #e5e7eb) !important;
    padding: 0.5rem;
    min-height: 100px;
  }

  .p-chips-token {
    margin: 5px !important;
    background-color: var(--primary-color, #3b82f6);
    color: var(--primary-color-text, #ffffff);
    border-radius: 6px;
    font-weight: 500;
  }
`;

const ErrorText = styled.small`
  color: var(--red-500, #ef4444);
  margin-top: 4px;
  display: block;
`;

const Skills = ({ defaultData =[], loading=false, onSave, onBack }) => {
  // Extracting skill names from the provided data
  const [skills, setSkills] = useState([]); 
  
  const [skillsError, setSkillsError] = useState({});

  useEffect(() => {
    if (defaultData) {
      // Some skills may arrive as plain strings, others as {name} objects, and
      // occasionally several skills get lumped into one entry separated by / , ; etc.
      const flattened = defaultData
        .map((skill) => (typeof skill === 'string' ? skill : skill?.name))
        .filter(Boolean)
        .flatMap((name) => name.split(/[\n/;|•]+|,\s*/).map((s) => s.trim()))
        .filter(Boolean);
      setSkills([...new Set(flattened)]);
    }
  }, [defaultData])

  // Validation Schema
  const schema = Yup.array().of(
    Yup.object({
      name: Yup.string().required("Skill name is required"),
    })
  );

  const handleInputChange = (value) => {
    setSkills(value); // Directly update the skills array
  };

  const handleSubmitData = () => {
    handleSubmit(skills.map(skill => ({ name: skill })), schema, setSkillsError, onSave);
  };

  return (
    <div style={{ padding: "20px 0" }}>
      <CardContainer>
        <CardHeader>
          <h3>Your Skills</h3>
        </CardHeader>
        
        <Flex direction="column" gap="8px" style={{ width: '100%' }}>
          <label style={{ fontSize: "0.9rem", color: "#4b5563", fontWeight: "500", marginBottom: "8px" }}>
            Add your skills (Press Enter after each skill)
          </label>
          <StyledChips
            value={skills}
            onChange={(e) => handleInputChange(e.value)}
            placeholder="E.g. JavaScript, React, Python, Management..."
          />
          {skillsError?.name && <ErrorText>{skillsError.name}</ErrorText>}
        </Flex>
      </CardContainer>

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "24px" }}>
        <Button
          label="Save & Continue"
          loading={loading}
          disabled={loading}
          icon="pi pi-check"
          className="p-button-primary"
          onClick={handleSubmitData}
        />
      </div>
    </div>
  );
};

export default Skills;
